'use client'

// @ts-nocheck
import BannerSlider from '../../../pages/HomePage/components/BannerSlider'
import { BannerTypes } from '../api'

import styles from './BannerListing.module.scss'

interface SliderProps {
  banners: BannerTypes[]
  placement: string
}

const BannerListing = ({ banners, placement }: SliderProps) => {
  return (
    <div className={styles.wrapper}>
      <BannerSlider banners={banners} creativeSlotSeoPrefix={placement} />
    </div>
  )
}

export default BannerListing
